<div fxLayout="row">
  <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="10px">
    <evc-nav-button class="filter-btn" type="secondary" variant="square" leftIcon="filter" size="sm" (click)="openAddFilterDialog()">
      {{ "inspectionlist.filter" | translate }}
    </evc-nav-button>
  </div>

  <div #filterContentsElem class="filter-items-content" fxLayout="row wrap" fxLayoutAlign="start" fxLayoutGap="12px" fxFlexOffset="12px">
    <ng-container *ngFor="let filter of filterData">
      <div class="filter-content">
        <span class="label">
          {{ filter.label }}
          <mat-icon class="clear" (click)="clearFilter(filter)">clear</mat-icon>
        </span>
      </div>
    </ng-container>
  </div>
</div>
